// Dependency
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import cls from './InqueryCreate.module.scss'

// Service model
import ClientGetInfo from '../../models/globalVariables'
import Respondent from '../../models/respondent'
import Inquiry from '../../models/inquiry'

// Components
import Header from '../../components/SecondHeader/Header'
import Breadcrumbs from '../../components/Breadcrumb'
import Filter from '../../components/Filter'
import { StyledTab, StyledTabs } from '../../components/StyledTabs'
import { TabPanel } from '../../components/Tab/TabBody'
import ClientInfo from '../../components/ClientInfo/clientInfo'
import TableIndex from '../../components/itemResearcherTable/TableIndex'

// Functions
import { NumberFomat } from '../../functions/numberFormat'
import ClientCalendar from '../../components/ClientInfo/clientCalendar'
import axios from '../../utils/axios'
import { Instraction } from '../../components/Instratuction/instraction'
import InfoTable from '../../components/TolokaInfoTable/AnswerItem'

const CompanresearcherListItem = () => {
  const param = useParams()
  const [status, setStatus] = useState(0)
  const { t } = useTranslation()
  const [tabvalue, settabvalue] = useState(0)
  const [dataSourse, setdataSourse] = useState([])
  const [clientInfoData, setclientInfoDate] = useState([])
  const [getInquiry, setGetInquiry] = useState(false)
  const [duration, setDuration] = useState()
  const [pageLimit, setPageLimit] = useState(10)
  const [items, setItems] = useState({})
  const [toloka, setToloka] = useState()
  const pageCount = 10
  const [getId, setGetId] = useState({
    survey_id: '',
    respondent_id: '',
  })
  const tabLabel = (text, isActive = false) => {
    return <span className='px-1'>{text}</span>
  }
  const backgroundColorTab = (text) => {
    switch (text) {
      case 'В ожидании':
        return 'linear-gradient(0deg, rgba(248, 221, 78, 0.3), rgba(248, 221, 78, 0.3)), #FFFFFF'
      case 'Отмененные':
        return 'linear-gradient(0deg, rgba(247, 102, 89, 0.15), rgba(247, 102, 89, 0.15)), #FFFFFF'
      case 'Подтвержденный':
        return 'linear-gradient(0deg, rgba(64, 148, 247, 0.15), rgba(64, 148, 247, 0.15)), #FFFFFF'
      case 'Завершенные':
        return 'linear-gradient(0deg, rgba(56, 217, 185, 0.2), rgba(56, 217, 185, 0.2)), #FFFFFF'
      default:
        return '#fff'
    }
  }
  const statusLabel = (text, num, isActive) => {
    return (
      <div
        style={{
          display: 'flex',
          background: isActive ? backgroundColorTab(text) : 'transparent',
          borderRadius: '6px',
          padding: '4px 16.5px',
        }}
      >
        <span
          style={{
            color: `${
              text === 'В ожидании'
                ? '#D29404'
                : text === 'Отмененные'
                ? '#F76659'
                : text === 'Подтвержденный'
                ? '#4094F7'
                : text === 'Завершенные'
                ? '#1AC19D'
                : '#4094F7'
            }`,
          }}
          className='px-1'
        >
          {text}
        </span>
        <span
          style={{
            color: `${
              text === 'В ожидании'
                ? '#D29404'
                : text === 'Отмененные'
                ? '#F76659'
                : text === 'Подтвержденный'
                ? '#4094F7'
                : text === 'Завершенные'
                ? '#1AC19D'
                : '#4094F7'
            }`,
          }}
          className='px-1'
        >
          {num}
        </span>
      </div>
    )
  }
  const handleSubmit = (data) => {}

  const [columnName, setcolumnName] = useState([
    t('number.icon'),
    t('full.name'),
    t('Phone'),
    t('email.name'),
    // t("Рейтинг"),
    t('status'),
    ' ',
  ])
  const routes = [
    {
      title: t('company.name'),
      link: true,
      route: '/home/company',
    },
  ]
  const a11yProps = (index) => {
    return {
      id: `full-width-tab-${index}`,
      'aria-controls': `full-width-tabpanel-${index}`,
    }
  }
  const handleChangeTab = (event, newvalue) => {
    settabvalue(newvalue)
  }
  const formik = useFormik({
    initialValues: {
      lastname: '',
    },
    onSubmit: handleSubmit,
    validationSchema: Yup.object().shape({
      lastname: Yup.string().strict(true).required('это требовалось'),
    }),
  })

  const renderErrorMessage = (field) => {
    return (
      formik.touched[field] && (
        <div class='text-error'>{formik.errors[field]}</div>
      )
    )
  }
  const [allTabs, setAllTabs] = useState(null)
  const getTabs = () => {
    axios
      .get(`/inquiry/tab?inquiry_id=${param.inquiry_id}`)
      .then((res) => {
        console.log(res)
        setAllTabs(res.data)
      })
      .catch((err) => console.log(err))
  }
  const selectStatusId = (num) => {
    switch (num) {
      case 0:
        return '01ee5c38-5f56-4e72-9b5a-926e4adce26a'
      case 1:
        return 'e86c9b5b-5c71-48c8-b61f-42eeb51e33c6'
      case 2:
        return '2e857fbe-9add-4eae-a8c4-fe57fb384347'
      case 3:
        return '2a98c22e-cbee-49f9-90ef-f56429d96333'
      default:
        return ''
    }
  }
  const getRespondents = () => {
    Inquiry.getInquiryRespondents({
      inquiry_id: param.inquiry_id,
      status_id: selectStatusId(status),
      page: pageLimit / pageCount,
      limit: 10,
    }).then((res) => {
      console.log(res)
      setdataSourse(res.data)
      setItems(res.data)
    })
  }
  const getToloka = () => {
    const params = {
      sort: 'created',
      pool_id: clientInfoData[0]?.pool_id,
      // status: "ACTIVE",
    }
    axios
      .get('/toloka/responses', {
        params,
      })
      .then((res) => {
        console.log('res', res)
        setToloka(JSON.parse(res.data))
      })
      .catch((err) => {
        console.log('err', err)
      })
  }

  const clientinfo = (id) => {
    ClientGetInfo.clientInfo(param.inquiry_id).then((res) => {
      setDuration(res.data.duration)
      setGetId({
        ...getId,
        survey_id: res.data.screener_survey_id,
      })
      setclientInfoDate([res.data])
    })
  }
  useEffect(() => {
    clientInfoData[0]?.pool_id && getToloka()
    clientinfo(param.researcheId)
    getRespondents()
    getTabs()
  }, [clientInfoData[0]?.pool_id])
  useEffect(() => {
    if (getInquiry) {
      getRespondents()
      setGetInquiry(false)
    }
  }, [getInquiry])
  useEffect(() => {
    getRespondents()
  }, [status])
  return (
    <div>
      <Header startAdornment={[<Breadcrumbs routes={routes} />]} />
      <Filter>
        <StyledTabs
          value={tabvalue}
          onChange={handleChangeTab}
          centered={false}
          aria-label='full width tabs example'
          TabIndicatorProps={{ children: <span className='w-2' /> }}
        >
          <StyledTab
            label={tabLabel(t('company.info'))}
            {...a11yProps(0)}
            style={{ width: '100px' }}
          />
          <StyledTab
            label={
              <div className={cls.respondents_tabBlock}>
                <div className={cls.respondents_lable}>
                  {tabLabel('Респонденты')}
                </div>
                {allTabs?.pending ? (
                  <div className={cls.respondents__index}>
                    {allTabs?.pending}
                  </div>
                ) : null}
              </div>
            }
            {...a11yProps(0)}
            style={{ width: '100px' }}
          />
          {clientInfoData[0]?.study_type !== 'toloka' && (
            <StyledTab
              label={tabLabel(t('Календарь'))}
              {...a11yProps(0)}
              style={{ width: '100px' }}
            />
          )}
          <StyledTab
            label={tabLabel(t('Инструкция'))}
            {...a11yProps(0)}
            style={{ width: '100px' }}
          />
        </StyledTabs>
      </Filter>
      {tabvalue === 1 && clientInfoData[0]?.study_type !== 'toloka' && (
        <div id='tab_status'>
          <Filter status={true}>
            <StyledTabs
              value={status}
              onChange={(event, newValue) => {
                setStatus(newValue)
              }}
              centered={false}
              aria-label='full width tabs example'
              TabIndicatorProps={{ children: <span className='w-2' /> }}
            >
              <StyledTab
                label={statusLabel(
                  t('pending'),
                  allTabs?.pending,
                  Boolean(status === 0)
                )}
                {...a11yProps(0)}
                style={{ width: '200px' }}
              />
              <StyledTab
                label={statusLabel(
                  t('confirm'),
                  allTabs?.confirmed,
                  Boolean(status === 1)
                )}
                {...a11yProps(0)}
                style={{ width: '200px' }}
              />
              <StyledTab
                label={statusLabel(
                  t('done'),
                  allTabs?.finished,
                  Boolean(status === 2)
                )}
                {...a11yProps(0)}
                style={{ width: '200px' }}
              />
              <StyledTab
                label={statusLabel(
                  t('canceliation'),
                  allTabs?.canceled,
                  Boolean(status === 3)
                )}
                {...a11yProps(0)}
                style={{ width: '200px' }}
              />
            </StyledTabs>
          </Filter>
        </div>
      )}
      <div>
        <TabPanel value={tabvalue} index={0}>
          <ClientInfo
            dataSourse={dataSourse}
            NumberFormat={NumberFomat}
            clientInfoData={clientInfoData}
          />
        </TabPanel>
        <TabPanel value={tabvalue} index={1}>
          {clientInfoData[0]?.study_type === 'toloka' ? (
            <InfoTable
              getTabs={getTabs}
              getRespondents={getRespondents}
              pageLimit={pageLimit}
              items={items}
              toloka={toloka}
              pageCount={pageCount}
              setPageLimit={setPageLimit}
              getId={getId}
              setGetInquiry={setGetInquiry}
              dataSourse={dataSourse}
              setdataSourse={setdataSourse}
              column={columnName}
              clientInfoData={clientInfoData}
            />
          ) : (
            <TableIndex
              getTabs={getTabs}
              getRespondents={getRespondents}
              pageLimit={pageLimit}
              items={items}
              pageCount={pageCount}
              setPageLimit={setPageLimit}
              getId={getId}
              setGetInquiry={setGetInquiry}
              dataSourse={dataSourse}
              setdataSourse={setdataSourse}
              column={columnName}
            />
          )}
        </TabPanel>
        {clientInfoData[0]?.study_type !== 'toloka' ? (
          <TabPanel value={tabvalue} index={2}>
            <ClientCalendar duration={duration} />
          </TabPanel>
        ) : (
          <TabPanel value={tabvalue} index={2}>
            <Instraction />
          </TabPanel>
        )}
        <TabPanel value={tabvalue} index={3}>
          <Instraction />
        </TabPanel>
      </div>
    </div>
  )
}

export default CompanresearcherListItem
